﻿export class ViewInfoRequested {
    currentUserId: string;
    currentUsername: string;
    currentUserDisplayName: string;
    definitionName: string;
    definitionVersion: string;
    workItemId: string;

    static eventName() { return 'ViewInfoRequested'; }

    eventName = ViewInfoRequested.eventName;
}